import { ThemeProvider } from "@mui/material";
import { mainTheme } from "./variants/main-theme";

const MyThemeProvider = ({ children }) => {
  return <ThemeProvider theme={mainTheme}>{children}</ThemeProvider>;
};
export default MyThemeProvider;
